import { styled, keyframes } from '@mui/material';
import { Image } from 'core/common/ui/ui-kit/Image';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderContainerStyled = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.background.mainBodyDesktop};
`;

export const ContainerStyled = styled('div')`
  position: relative;
`;

export const RotatingGalaxyStyled = styled(Image)`
  animation: ${rotate} 12s linear infinite;
`;

export const LogoStyled = styled(Image)`
  position: absolute;
  top: 50%;
  left: 50%;
  animation: ${fadeIn} 200ms ease-out;
  transform: translate(-50%, -50%);
`;
